import { z } from 'zod';
/**
 * Projekt-Cloning (Plan §E, Issue #81).
 *
 * "Klone dieses Projekt" — erzeugt ein neues Projekt mit derselben Konfiguration
 * wie ein existierendes (selber Kunde, alle Brandschutz-/Building-Felder
 * uebernommen, Status=draft, neue ID).
 *
 * Pro uebernommenes Feld wird ein FieldSource(kind=clone) Eintrag angelegt,
 * damit später visuell sichtbar ist "dieses Feld stammt aus Projekt X".
 *
 * Body-Optionen erlauben optional einen anderen Titel oder Kunden.
 */
export const cloneProjectRequest = z
    .object({
    title: z.string().min(2).max(120).optional(),
    customerId: z.number().int().positive().optional(),
})
    .strict();
